var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_circle_outline",
    clipPath: "url(#clip0_45_3743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 4.66683C7.6335 4.66683 7.3335 4.96683 7.3335 5.3335V7.3335H5.3335C4.96683 7.3335 4.66683 7.6335 4.66683 8.00016C4.66683 8.36683 4.96683 8.66683 5.3335 8.66683H7.3335V10.6668C7.3335 11.0335 7.6335 11.3335 8.00016 11.3335C8.36683 11.3335 8.66683 11.0335 8.66683 10.6668V8.66683H10.6668C11.0335 8.66683 11.3335 8.36683 11.3335 8.00016C11.3335 7.6335 11.0335 7.3335 10.6668 7.3335H8.66683V5.3335C8.66683 4.96683 8.36683 4.66683 8.00016 4.66683ZM8.00016 1.3335C4.32016 1.3335 1.3335 4.32016 1.3335 8.00016C1.3335 11.6802 4.32016 14.6668 8.00016 14.6668C11.6802 14.6668 14.6668 11.6802 14.6668 8.00016C14.6668 4.32016 11.6802 1.3335 8.00016 1.3335ZM8.00016 13.3335C5.06016 13.3335 2.66683 10.9402 2.66683 8.00016C2.66683 5.06016 5.06016 2.66683 8.00016 2.66683C10.9402 2.66683 13.3335 5.06016 13.3335 8.00016C13.3335 10.9402 10.9402 13.3335 8.00016 13.3335Z",
    fill: "#7C8D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_3743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutline);
export default __webpack_public_path__ + "static/media/add_circle_outline.86fa501a09a78ed0d228b60e45db8f84.svg";
export { ForwardRef as ReactComponent };